// @ts-nocheck
const CustomerDashboardSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default CustomerDashboardSkeleton